/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/common';
import * as import4 from '@angular/forms';
import * as import5 from '../../../app/messages/message-thread.component';
import * as import6 from '../../../app/services/api.service';
import * as import7 from '../../../app/services/user.service';
import * as import8 from '../../../app/services/messages.service';
import * as import9 from '@angular/router';
import * as import10 from 'angular2-notifications/src/notifications.service';
import * as import11 from '../../../app/services/response.service';
import * as import12 from '../../../app/services/local-storage.service';
import * as import13 from '../../../app/services/date.service';
const styles_MessageThreadComponent:any[] = ([] as any[]);
export const RenderType_MessageThreadComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MessageThreadComponent,
  data: {}
}
);
function View_MessageThreadComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie wiadomości'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_MessageThreadComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'p',[[
        'class',
        'uploading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                        ',
      '\n                                        '
    ]
    )),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'btn btn-small btn-danger'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.removeFile(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Usuń'])),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.filename;
    ck(v,1,0,currVal_0);
  });
}
function View_MessageThreadComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),18,'article',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpad(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'ticket-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'time options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'p',[[
        'style',
        'white-space: pre-line;'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ((v.context.$implicit['SenderType'] != 'customer')? ck(v,4,0,'reply'): import0.ɵEMPTY_ARRAY);
    ck(v,3,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (v.context.$implicit['FromRealname'] || ((v.context.$implicit['SenderType'] != 'customer')? 'BOK Data Space': 'Firma'));
    ck(v,7,0,currVal_1);
    const currVal_2:any = import0.ɵunv(v,10,0,ck(v,11,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.dateService.formatDate(v.context.$implicit.Created),'dd.MM.yyyy HH:mm'));
    ck(v,10,0,currVal_2);
    const currVal_3:any = v.context.$implicit.Body;
    ck(v,16,0,currVal_3);
  });
}
function View_MessageThreadComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),79,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),76,'section',[[
        'class',
        'tickets thread'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),70,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'meta'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'class',
        'ticket-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'status'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Numer:\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'status'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Status:\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),49,'div',[[
        'class',
        'reply-form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),46,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,28).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,28).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.sendReply()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import4.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import4.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },{ngSubmit: 'ngSubmit'}),
    import0.ɵprd(2048,(null as any),import4.ControlContainer,(null as any),[import4.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import4.NgControlStatusGroup,[import4.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'textarea',[
      [
        'class',
        'extended'
      ]
      ,
      [
        'formControlName',
        'message'
      ]
      ,
      [
        'placeholder',
        'Wpisz odpowiedź'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,35)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,35).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,35)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,35)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import4.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import4.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import4.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import4.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import4.FormControlName,[
      [
        3,
        import4.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import4.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import4.NgControl,(null as any),[import4.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import4.NgControlStatus,[import4.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),29,'div',[[
        'class',
        'row-standard extended'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MessageThreadComponent_3)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'link fileinput-button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dodaj plik'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,[[
        'fileInput',
        1
      ]
    ],(null as any),0,'input',[
      [
        'accept',
        'image/*,.pdf,.png,.jpg'
      ]
      ,
      [
        'class',
        'fileupload'
      ]
      ,
      [
        'id',
        'uploaded_files'
      ]
      ,
      [
        'type',
        'file'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'change'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>co.onFileChange($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'info row-small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['jpeg, png, pdf – max 2MB'])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'pull-right options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-short'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Wyślij'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MessageThreadComponent_4)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_10:any = co.replyForm;
    ck(v,28,0,currVal_10);
    const currVal_18:any = 'message';
    ck(v,37,0,currVal_18);
    const currVal_19:any = co.selectedFiles;
    ck(v,49,0,currVal_19);
    const currVal_20:any = co.articles;
    ck(v,77,0,currVal_20);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.ticket['Title'] || 'Brak tematu');
    ck(v,9,0,currVal_0);
    const currVal_1:any = co.ticket['TicketNumber'];
    ck(v,14,0,currVal_1);
    const currVal_2:any = co.messagesStatuses[co.ticket['StateID']];
    ck(v,20,0,currVal_2);
    const currVal_3:any = import0.ɵnov(v,30).ngClassUntouched;
    const currVal_4:any = import0.ɵnov(v,30).ngClassTouched;
    const currVal_5:any = import0.ɵnov(v,30).ngClassPristine;
    const currVal_6:any = import0.ɵnov(v,30).ngClassDirty;
    const currVal_7:any = import0.ɵnov(v,30).ngClassValid;
    const currVal_8:any = import0.ɵnov(v,30).ngClassInvalid;
    const currVal_9:any = import0.ɵnov(v,30).ngClassPending;
    ck(v,26,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_11:any = import0.ɵnov(v,39).ngClassUntouched;
    const currVal_12:any = import0.ɵnov(v,39).ngClassTouched;
    const currVal_13:any = import0.ɵnov(v,39).ngClassPristine;
    const currVal_14:any = import0.ɵnov(v,39).ngClassDirty;
    const currVal_15:any = import0.ɵnov(v,39).ngClassValid;
    const currVal_16:any = import0.ɵnov(v,39).ngClassInvalid;
    const currVal_17:any = import0.ɵnov(v,39).ngClassPending;
    ck(v,34,0,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17);
  });
}
export function View_MessageThreadComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import3.DatePipe,[import0.LOCALE_ID]),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MessageThreadComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MessageThreadComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import5.MessageThreadComponent = v.component;
    const currVal_0:any = co.messagesThreadLoading;
    ck(v,2,0,currVal_0);
    const currVal_1:boolean = !co.messagesThreadLoading;
    ck(v,5,0,currVal_1);
  },(null as any));
}
function View_MessageThreadComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-message-thread',([] as any[]),(null as any),(null as any),(null as any),View_MessageThreadComponent_0,RenderType_MessageThreadComponent)),
    import0.ɵdid(4308992,(null as any),0,import5.MessageThreadComponent,[
      import6.ApiService,
      import7.UserService,
      import8.MessagesService,
      import9.ActivatedRoute,
      import10.NotificationsService,
      import11.ResponseService,
      import12.LocalStorageService,
      import13.DateService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const MessageThreadComponentNgFactory:import0.ComponentFactory<import5.MessageThreadComponent> = import0.ɵccf('app-message-thread',import5.MessageThreadComponent,View_MessageThreadComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/messages/message-thread.component.ngfactory.ts